import React from 'react';
import { Divider } from 'semantic-ui-react'

const RtesFact1 = ({autorizacUA, styles, handleClickRegr, handleClickSel1, handleClickSel2}) => {
  const a151501 = autorizacUA.findIndex( autorizac => autorizac === "151501" );
  const a151505 = autorizacUA.findIndex( autorizac => autorizac === "151505" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      
      <Divider inverted />

      {a151501!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large dollar sign violet icon"></i>
        Facturación
      </button>
      }
      {a151505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large dollar sign violet icon"></i>
        Impuestos
      </button>
      }
    </div>
  )
};

export default RtesFact1
